module.exports = __webpack_public_path__ + "img/slide-14-2.49b1cc3f.jpg";